<template>
    <div class="down-list-container">
        <el-dropdown @command="onSelect">
            <button class="el-dropdown-link" type="button">
                {{ selectedLabel }}
                <el-icon class="el-icon--right"><arrow-down /></el-icon>
            </button>
            <template #dropdown>
                <el-dropdown-menu>
                    <el-dropdown-item v-for="item in items" :key="item.value || item" :command="item.value || item">
                        {{ item.label || item }}
                    </el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>
/* eslint-env vue/setup-compiler-macros */

<script setup>
import { computed } from 'vue'
import { ArrowDown } from '@element-plus/icons-vue'

const props = defineProps({
    label: { type: String, required: true },
    items: { type: Array, required: true },
    modelValue: { type: [String, Number], default: '' }
})
const emit = defineEmits(['update:modelValue'])

const selectedLabel = computed(() => {
    if (!props.modelValue) return props.label
    const found = props.items.find(
        i => (i.value ?? i) === props.modelValue
    )
    return found ? (found.label ?? found) : props.label
})

function onSelect(val) {
    emit('update:modelValue', val)
}
</script>

<style lang="scss">
.down-list-container {
    padding: 0 0 0 0;
}

.block-col-2 .demonstration {
    display: block;
    margin-bottom: 20px;
}

.el-dropdown-link {
    align-items: center;
    background: #ffffff;
    border: 1px solid #dbe3ee;
    border-radius: 999px;
    color: #334155;
    cursor: pointer;
    display: inline-flex;
    font-family: var(--app-font);
    font-size: 0.9rem;
    font-weight: 600;
    gap: 0.35rem;
    min-height: 38px;
    padding: 0.45rem 0.75rem;
    transition: background 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, color 0.2s ease;
    user-select: none;
}

.el-dropdown-link:hover,
.el-dropdown-link:focus-visible {
    background: #faf5ff;
    border-color: rgba(136, 0, 255, 0.28);
    box-shadow: 0 0 0 3px rgba(136, 0, 255, 0.08);
    color: var(--purple);
    outline: none;
}

.el-dropdown-link:active {
    transform: translateY(1px);
}
</style>
